import client from 'core/axios';

export const FILE_UPLOAD_ERROR_CODE = Object.freeze({
  SIZE_LIMIT_EXCEEDED: 'SIZE_LIMIT_EXCEEDED',
  FILE_TYPE_NOT_SUPPORTED: 'FILE_TYPE_NOT_SUPPORTED',
});

const BYTES_IN_MB = 1048576;

export const sizeLimit = BYTES_IN_MB * 40;
export default async function commonUpload(
  file,
  maxSize = sizeLimit,
  allowImageBasedPdf = false,
) {
  try {
    if (file.size > maxSize) {
      return {
        error: `The uploaded file exceeds ${Math.round(
          maxSize / BYTES_IN_MB,
        )}MB in size, please select a smaller file`,
        errorCode: FILE_UPLOAD_ERROR_CODE.SIZE_LIMIT_EXCEEDED,
      };
    }
    const body = new FormData();
    body.append('file', file);
    const { status, data } = await client.postForm(`v1/common/upload`, body, {
      params: {
        allow_image_based_pdf: allowImageBasedPdf,
      },
      // Increase timeout amount to 10 minutes
      timeout: 10 * 1000 * 60,
    });
    if (status === 201) {
      return data;
    }
    if (status === 400) {
      return {
        error: {
          message: 'This file type is not supported',
          errorCode: FILE_UPLOAD_ERROR_CODE.FILE_TYPE_NOT_SUPPORTED,
        },
      };
    }
  } catch (error) {
    console.warn('There was a problem uploading this file', error);
    // Error structure must match network errors shown above
    return {
      error: error.message,
      errorCode: 0,
      errorData: error?.response?.data,
    };
  }
  return {};
}
